export const VIEW_TYPES = {
  COMMENTS: 'COMMENTS',
  PROGRESS_HISTORY: 'PROGRESS_HISTORY',
  ACTIVITY_LOG: 'ACTIVITY_LOG'
}
